import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { f as focusOutline } from '../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { I as InlineAlert } from '../InlineAlert/InlineAlert-DGAsFX2G.js';

const InputWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-jvxdi0-0"
})(["width:100%;max-width:", ";display:inline-flex;flex-direction:column;flex-wrap:nowrap;justify-content:flex-start;align-content:stretch;align-items:stretch;gap:", ";", " ", ""], ({
  $fullWidth,
  theme
}) => $fullWidth ? 'none' : theme.input.maxWidth, ({
  $inline,
  theme
}) => $inline ? theme.spacing.xxsmall.default : theme.spacing.xxxxsmall.default, ({
  $inline
}) => $inline && css(["max-width:none;flex-direction:row;align-content:center;align-items:center;"]), isMobile(css(["gap:", ";max-width:none;"], ({
  $inline,
  theme
}) => $inline ? theme.spacing.xxsmall.default : theme.spacing.xxxsmall.mobile)));
const inputStyles = /*#__PURE__*/css(["width:100%;font:", ";background:unset;border:unset;border-color:unset;padding:unset;border-radius:unset;color:", ";position:relative;align-self:center;flex:1 1 auto;transition:unset;margin-block-start:0;margin-block-end:0;min-width:0;appearance:none;", " @media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease,box-shadow 100ms ease;}::placeholder{color:", " !important;}:disabled{cursor:not-allowed;outline:none;opacity:1;color:", ";box-shadow:none;background-color:", ";::placeholder{color:", " !important;}}:focus,:focus-within{outline:none;background:none;}"], ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.text.color.default, isMobile(css(["font:", ";"], ({
  theme
}) => theme.font.text.base.mobile)), ({
  theme
}) => theme.text.color.tertiary, ({
  theme
}) => theme.text.color.unavailable, ({
  theme
}) => theme.input.backgroundColor.unavailable, ({
  theme
}) => theme.text.color.unavailable);

/** aui style */
const auiMixin = /*#__PURE__*/css(["&[type=\"text\"]:focus,&[type=\"search\"]:focus,&[type=\"number\"]:focus,&[type=\"tel\"]:focus,&[type=\"password\"]:focus{outline:none;box-shadow:none;border:none;}"]);
const styleInputMixin = /*#__PURE__*/css(["background-color:transparent;border:none;border-style:none;border-width:unset;box-shadow:none;height:auto;line-height:normal;outline:none;padding:0;", " ", " &[type=\"number\"]::-webkit-inner-spin-button{fill:red !important;background-color:red !important;}&[type=\"color\"]{align-self:auto;}box-sizing:border-box;min-height:", ";", " ::-ms-clear{display:none;width :0;height:0;}::-ms-reveal{display:none;width :0;height:0;}::-webkit-search-decoration,::-webkit-search-cancel-button,::-webkit-search-results-button,::-webkit-search-results-decoration{display:none;}::-webkit-calendar-picker-indicator{background:none;}"], inputStyles, auiMixin, ({
  theme
}) => theme.spacing.base.default, isMobile(css(["min-height:", ";"], ({
  theme
}) => theme.spacing.base.mobile)));
const InputContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40026394__sc-jvxdi0-1"
})(["flex:1 1 auto;display:flex;padding-inline:", ";padding-block:", ";", " && > *{", "}"], ({
  theme
}) => theme.controls.paddingInline.large.default, ({
  theme
}) => theme.controls.paddingBlock.base.default, isMobile(css(["padding-inline:", ";padding-block:", ";"], ({
  theme
}) => theme.controls.paddingInline.large.mobile, ({
  theme
}) => theme.controls.paddingBlock.base.mobile)), styleInputMixin);
const InputValidationMessage = /*#__PURE__*/styled(InlineAlert).withConfig({
  componentId: "sc-storm-ui-40026394__sc-jvxdi0-2"
})(["margin-top:0;margin-bottom:0;flex-shrink:0;"]);
const statusMixin = ({
  $statusType
}) => {
  if ($statusType === 'error') {
    return css(["border:", ";"], ({
      theme
    }) => theme.support.border.error);
  }
  if ($statusType === 'warning') {
    return css(["border:", ";"], ({
      theme
    }) => theme.support.border.warning);
  }
  if ($statusType === 'success') {
    return css(["border:", ";"], ({
      theme
    }) => theme.support.border.success);
  }
  return css([""]);
};
const InputGroup = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-jvxdi0-3"
})(["background-color:", ";color:", ";border-width:", ";border-style:solid;border-color:", ";", " border-radius:", ";flex:1 0 0;box-shadow:", ";:hover{box-shadow:", ";border-color:", ";", "}box-sizing:border-box;display:flex;", ";:focus-within{", "}"], ({
  theme
}) => theme.input.backgroundColor.default, ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.border.width.default, ({
  theme
}) => theme.border.color.medium.default, statusMixin, ({
  theme
}) => theme.border.radius.medium, ({
  theme
}) => theme.input.innerShadow, ({
  theme
}) => theme.elevation.shadow.card, ({
  theme
}) => theme.border.color.medium.hover, statusMixin, ({
  $disabled
}) => $disabled && css(["background-color:", ";color:", ";border-color:", ";box-shadow:none;:hover{box-shadow:none;border-color:", ";}"], ({
  theme
}) => theme.input.backgroundColor.unavailable, ({
  theme
}) => theme.text.color.unavailable, ({
  theme
}) => theme.border.color.medium.unavailable, ({
  theme
}) => theme.border.color.medium.unavailable), focusOutline);

export { InputWrapper as I, InputGroup as a, InputContainer as b, InputValidationMessage as c, inputStyles as i };
//# sourceMappingURL=Input.styles-DOCgF0N8.js.map
